export var PatientCardsEvents={Refresh:'patient.cards.events.refresh'};